import React, { useEffect, useState } from "react";
import { FiWifiOff } from "react-icons/fi";

const Offline: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if (isOnline) {
      window.location.reload();
    }
  }, [isOnline]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-6 text-center">
      <FiWifiOff size={72} className="text-gray-400 mb-6" />
      <h1
        className="text-2xl font-bold text-gray-800 mb-3"
        style={{ fontFamily: "Poppins, sans-serif" }}
      >
        Tidak ada koneksi internet
      </h1>
      <p
        className="text-gray-500 mb-8 max-w-xs text-base leading-relaxed"
        style={{ fontFamily: "Poppins, sans-serif" }}
      >
        Periksa koneksi internet Anda dan coba lagi.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="px-8 py-3 bg-[#004cbc] text-white rounded-2xl font-semibold text-base shadow-lg hover:bg-blue-700 active:scale-95 transition-all min-h-[48px]"
        style={{ fontFamily: "Poppins, sans-serif" }}
      >
        Coba Lagi
      </button>
    </div>
  );
};

export default Offline;
